module.exports = __webpack_public_path__ + "img/spot-404.b5cca79f.svg";